import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDownIconXs } from '@lichtblick/icons/svg/chevron-down/chevron-down-xs';
import { Spacing } from '@lichtblick/theme';
import classNames from 'classnames';
import { forwardRef, useLayoutEffect, useRef, useState } from 'react';
import { Label } from '../label/label';
import { FieldFooter } from '../legacy-field-footer/field-footer';
import styles from './select-input.module.scss';
const SelectInputInner = ({ allowEmptySelection, className, fieldIcon: FieldIcon, icon, id, isDisabled, label, name, onChange, options, placeholder, statusLabel, statusType = 'default', value, ...props }, ref)=>{
    const iconRef = useRef(null);
    const [iconWidth, setIconWidth] = useState();
    const inputId = id || name;
    const labelId = `${inputId}_label`;
    const statusId = `${inputId}_validationMessage`;
    useLayoutEffect(()=>{
        const updateIconWidth = ()=>setIconWidth(iconRef.current?.getBoundingClientRect().width);
        updateIconWidth();
        window.addEventListener('resize', updateIconWidth);
        return ()=>window.removeEventListener('resize', updateIconWidth);
    }, []);
    const handleChange = (event)=>{
        onChange?.(event);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames(styles.wrapper, className),
        children: [
            Boolean(label) && /*#__PURE__*/ _jsx(Label, {
                bold: true,
                htmlFor: inputId,
                id: labelId,
                children: label
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: classNames(styles['input-row'], isDisabled && styles['input-row-disabled'], statusType !== 'default' && styles[`input-row-${statusType}`]),
                children: [
                    FieldIcon && /*#__PURE__*/ _jsx("div", {
                        className: styles['icon-wrapper'],
                        ref: iconRef,
                        children: /*#__PURE__*/ _jsx(FieldIcon, {})
                    }),
                    /*#__PURE__*/ _jsxs("select", {
                        className: styles.select,
                        ...props,
                        "aria-describedby": statusId,
                        "aria-invalid": statusType === 'error',
                        "aria-labelledby": labelId,
                        disabled: isDisabled,
                        id: inputId,
                        name: name,
                        onChange: handleChange,
                        ref: (instance)=>{
                            if (typeof ref === 'function') {
                                ref(instance);
                            } else if (ref) {
                                ref.current = instance;
                            }
                        },
                        style: {
                            paddingLeft: iconWidth ? `${iconWidth}px` : Spacing.Xs
                        },
                        value: value,
                        children: [
                            /*#__PURE__*/ _jsx("option", {
                                hidden: !allowEmptySelection,
                                value: "",
                                children: placeholder
                            }),
                            options.map(({ isHidden, label, value: optionValue })=>/*#__PURE__*/ _jsx("option", {
                                    hidden: isHidden,
                                    value: optionValue,
                                    children: label
                                }, `${optionValue}_${label}`))
                        ]
                    }),
                    !isDisabled && /*#__PURE__*/ _jsx("div", {
                        className: styles['arrow-wrapper'],
                        children: /*#__PURE__*/ _jsx(ChevronDownIconXs, {})
                    })
                ]
            }),
            Boolean(statusLabel) && /*#__PURE__*/ _jsx(FieldFooter, {
                icon: icon,
                id: statusId,
                label: statusLabel,
                state: statusType
            })
        ]
    });
};
/** @deprecated Use `Select` instead. */ export const SelectInput = /*#__PURE__*/ forwardRef(SelectInputInner);

//# sourceMappingURL=select-input.js.map